<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
    [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
    [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <div contenido class="contenidoClass">

    <div class="contenidoTablero">
      
      <div class="contenidoEncabezado">
				<div class="encabezado2 titulo-contenidomenu">
				  {{'gestion.formulacion.matRiesOport.factoresExternos'|translate}}
				</div>
				<div class="iconosE">
					<mat-icon class="iconoMen" [ngStyle]="{'color':'gray'}"
					[matMenuTriggerFor]="menu2">more_vert</mat-icon>
					<mat-menu #menu2="matMenu">
						<button (click)="exportar_excel()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
							<mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
							<span> {{'gestion.formulacion.matrizFoda.export'|translate}}</span>
						</button>
					</mat-menu>
				</div>
			</div>
      
      <div class="zonaTablas">
        @if (viewTablero) {
          @for(elem of diccionarioFLOA2; track elem){
            <app-contenedor-elementos class="tabla" [header]="{title: elem.externosss.elementoe}">
              <div body class="w3-scroll tab">
                <table class="tabla-aleema">
                  <thead>
                    <tr>
                      <th style="width: 3vw;">
                        #
                      </th>
                      <th>
                        {{elem.externosss.elementoe}}
                      </th>
                      <th *appRoles="permisos.ADMINISTRACION" style="width: 4vw;">
                        <mat-icon matTooltip="{{'gestion.formulacion.matRiesOport.tooltip1'|translate}}"
                        (click)="abrirFormAgregar(elem.externosss, true)"
                        class="iconoMen colorBotonDeNuevo">add_circle_outline</mat-icon>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    @for(item of elem.elementooo; track item; let i = $index) {
                      <tr>
                        <td>
                          {{obtCodigo(elem.externosss)}}{{i+1}} </td>
                        <td style="max-width: 20vw; overflow: hidden;" [matTooltip]="item.nombre" [appOverflowTooltip]="item.nombre">
                          {{item.nombre}}
                        </td>
                        <td *appRoles="permisos.ADMINISTRACION">
                          <mat-icon class="iconoMen"
                            matTooltip="{{'gestion.formulacion.matRiesOport.tooltip2'|translate}}"
                            (click)="abrirFormEdit(item,elem.externosss, true)">edit</mat-icon>
                          <mat-icon class="iconoMen"
                            matTooltip="{{'gestion.formulacion.matRiesOport.tooltip3'|translate}}"
                            (click)="alertas('eliminar',item)">delete</mat-icon>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </app-contenedor-elementos>
          }
        }@else {
          <div class="w3-half_e" style="height: 33vh;">
            <div class="w3-row w3-margin-left-caja w3-white" style="height: 32.8vh; padding: 0% 2%;">
              <app-skeleton-table [columnas]="3" [filas]="6"/>
            </div>
          </div>
          <div class="w3-half_e" style="height: 33vh;">
            <div class="w3-row w3-margin-left-caja w3-white" style="height: 32.8vh; padding: 0% 2%;">
              <app-skeleton-table [columnas]="3" [filas]="6"/>
            </div>
          </div>
        }
      </div>

      <div class="encabezado2 titulo-contenidomenu">
				{{'gestion.formulacion.matRiesOport.factoresExternos'|translate}}
      </div>
      <div class="zonaTablas">
        @if (viewTablero) {
          @for(elem of diccionarioFLOA1; track elem){
            <app-contenedor-elementos class="tabla" [header]="{title: elem.internosss.elementoi}">
              <div body class="w3-scroll tab">
                <table class="tabla-aleema">
                  <thead>
                    <tr>
                      <th style="width: 3vw;">
                        #
                      </th>
                      <th>
                        {{elem.internosss.elementoi}}
                      </th>
                      <th>
                        <mat-icon matTooltip="{{'gestion.formulacion.matRiesOport.tooltip1'|translate}}"
                        (click)="abrirFormAgregar(elem.internosss, false)"
                        class="iconoMen colorBotonDeNuevo">add_circle_outline</mat-icon>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    @for(item of elem.elementooo; track item; let i = $index) {
                      <tr>
                        <td>
                          {{obtCodigo(elem.internosss)}}{{i+1}}
                        </td>
                        <td style="max-width: 20vw; overflow: hidden;" [matTooltip]="item.nombre" [appOverflowTooltip]="item.nombre">
                          {{item.nombre}}
                        </td>
                        <td *appRoles="permisos.ADMINISTRACION">
                          <mat-icon class="iconoMen"
                            matTooltip="{{'gestion.formulacion.matRiesOport.tooltip2'|translate}}"
                            (click)="abrirFormEdit(item,elem.internosss, false)">edit</mat-icon>
                          <mat-icon class="iconoMen"
                            matTooltip="{{'gestion.formulacion.matRiesOport.tooltip3'|translate}}"
                            (click)="alertas('eliminar',item)">delete</mat-icon>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </app-contenedor-elementos>
          }
        }@else {
          <div class="w3-half_e" style="height: 33vh;">
            <div class="w3-row w3-margin-left-caja w3-white" style="height: 32.8vh; padding: 0% 2%;">
              <app-skeleton-table [columnas]="3" [filas]="6"/>
            </div>
          </div>
          <div class="w3-half_e" style="height: 33vh;">
            <div class="w3-row w3-margin-left-caja w3-white" style="height: 32.8vh; padding: 0% 2%;">
              <app-skeleton-table [columnas]="3" [filas]="6"/>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</app-esqueleto-tableros>

<app-modal [isOpen]="modal2" [cerrar]="false" (close)="cerrarForm()">
  <div modal-header>
    {{'gestion.formulacion.matRiesOport.editarElem'|translate}}
  </div>

  <div modal-body>
    <form [formGroup]="formGeneral" style="padding-right: 1.5vw;">

      <!-- Campo nombre -->
      @if(formGeneral.hasError('isValid')){
      <mat-error class="error-message" style="margin-left: 10%; color: red;">
        {{'gestion.formulacion.matRiesOport.formText2'|translate}} <strong>
          {{'gestion.formulacion.matRiesOport.formText1'|translate}}.</strong>
      </mat-error>
      }
      @if(!esExterno){
      <!-- Interno -->
      <div class="form-group">
        <label for="nombreedit" class="form-label">
          {{'gestion.formulacion.matRiesOport.formText2'|translate}} *
        </label>
        <input type="text" id="nombreedit" formControlName="inputNameEdit" class="form-input anchosInputs"
        [matTooltip]="formGeneral.controls.inputNameEdit.value" [appOverflowTooltip]="formGeneral.controls.inputNameEdit.value"
          placeholder="{{'gestion.formulacion.matRiesOport.placeHolderNombre'|translate}}" required>
      </div>
      } @else {
      <!-- Externo -->
      <div class="form-group">
        <label for="nombreeditExt" class="form-label">
          {{'gestion.formulacion.matRiesOport.formText2'|translate}} *
        </label>
        <input type="text" id="nombreeditExt" formControlName="inputNameEditExt" class="form-input anchosInputs"
        [matTooltip]="formGeneral.controls.inputNameEditExt.value" [appOverflowTooltip]="formGeneral.controls.inputNameEditExt.value"
          placeholder="{{'gestion.formulacion.matRiesOport.placeHolderNombre'|translate}}" required>
      </div>
      }

      <!-- Campo pestel/perspectiva -->
      @if(!esExterno){
      <!-- Interno -->
      <div class="form-group">
        <label for="perspectiva" class="form-label">
          {{'gestion.formulacion.matRiesOport.formText6'|translate}} *
        </label>
        <select id="perspectiva" formControlName="inputPerspectiveEdit" class="contentSelect anchosInputs" required>
          <option value="default" disabled selected>
            {{'gestion.formulacion.matRiesOport.formText8'| translate}}
          </option>
          @for(pers of perspectiva; track pers){
            <option [value]="pers.id"
            [matTooltip]="pers.nombre" [appOverflowTooltip]="pers.nombre"> {{pers.nombre}} </option>
          }
        </select>
      </div>
      } @else{
      <!-- Externo -->
      <div class="form-group">
        <label for="pestel" class="form-label">
          {{'gestion.formulacion.matRiesOport.formText3'|translate}} *
        </label>
        <select id="pestel" formControlName="inputPerspectiveEditExt" class="contentSelect anchosInputs" required>
          <option value="default" disabled selected>
            {{'gestion.formulacion.matRiesOport.formText9'|translate}}
          </option>
          @for(pers of catalogo; track pers){
            <option [value]="pers.id"
            [matTooltip]="pers.name" [appOverflowTooltip]="pers.name"> {{pers.name}} </option>
          }
        </select>
      </div>
      }
    </form>
  </div>

  <app-button modal-footer
    [color]="'var(--color-cancel)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.cancel' | translate"
    (clickB)="cerrarForm()"
  />
  <app-button modal-footer
    [ngClass]="!esExterno?puede_guardarEdit():puede_guardarEditExt()"
    [color]="'var(--color-acept)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.Guardar' | translate"
    (clickB)="alertas('editar')"
  />
</app-modal>

<app-modal [isOpen]="modal" [cerrar]="false">
  <div modal-header>
    {{'gestion.formulacion.matRiesOport.agregarElem'|translate}}
  </div>

  <div modal-body>
    <form [formGroup]="formGeneral" style="padding-right: 1.5vw;">

      <!-- Campo nombre -->
      @if(formGeneral.hasError('isValid')){
      <mat-error class="error-message" style="margin-left: 10%; color: red;">
        {{'gestion.formulacion.matRiesOport.formText2'|translate}} <strong>
          {{'gestion.formulacion.matRiesOport.formText1'|translate}}.</strong>
      </mat-error>
      }
      @if(!esExterno){
      <!-- Interno -->
      <div class="form-group">
        <label for="nombreadd" class="form-label">
          {{'gestion.formulacion.matRiesOport.formText2'|translate}} *
        </label>
        <input type="text" id="nombreadd" formControlName="inputName" class="form-input anchosInputs"
        [matTooltip]="formGeneral.controls.inputName.value" [appOverflowTooltip]="formGeneral.controls.inputName.value"
          placeholder="{{'gestion.formulacion.matRiesOport.placeHolderNombre'|translate}}" required>
      </div>
      } @else {
      <!-- Externo -->
      <div class="form-group">
        <label for="nombreaddExt" class="form-label">
          {{'gestion.formulacion.matRiesOport.formText2'|translate}} *
        </label>
        <input type="text" id="nombreaddExt" formControlName="inputNameExt" class="form-input anchosInputs"
        [matTooltip]="formGeneral.controls.inputNameExt.value" [appOverflowTooltip]="formGeneral.controls.inputNameExt.value"
          placeholder="{{'gestion.formulacion.matRiesOport.placeHolderNombre'|translate}}" required>
      </div>
      }

      <!-- Campo pestel/perspectiva -->
      @if(!esExterno){
      <!-- Interno -->
      <div class="form-group">
        <label for="perspectiva" class="form-label">
          {{'gestion.formulacion.matRiesOport.formText6'|translate}} *
        </label>
        <select id="perspectiva" formControlName="inputPerspective" class="contentSelect anchosInputs" required>
          <option value="default" disabled selected>
            {{'gestion.formulacion.matRiesOport.formText8'| translate}}
          </option>
          @for(pers of perspectiva; track pers){
            <option [value]="pers.id"
            [matTooltip]="pers.nombre" [appOverflowTooltip]="pers.nombre"> {{pers.nombre}} </option>
          }
        </select>
      </div>
      } @else {
      <!-- Externo -->
      <div class="form-group">
        <label for="pestel" class="form-label">
          {{'gestion.formulacion.matRiesOport.formText3'|translate}} *
        </label>
        <select id="pestel" formControlName="inputPerspectiveExt" class="contentSelect anchosInputs" required>
          <option value="default" disabled selected>
            {{'gestion.formulacion.matRiesOport.formText9'|translate}}
          </option>
          @for(pers of catalogo; track pers){
            <option [value]="pers.id"
            [matTooltip]="pers.name" [appOverflowTooltip]="pers.name"> {{pers.name}} </option>
          }
        </select>
      </div>
      }
    </form>
  </div>

  <app-button modal-footer
    [color]="'var(--color-cancel)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.cancel' | translate"
    (clickB)="cerrarForm()"
  />
  <app-button modal-footer
    [ngClass]="!esExterno?puede_guardar():puede_guardarExt()"
    [color]="'var(--color-acept)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.Guardar' | translate"
    (clickB)="alertas('guardar')"
  />
</app-modal>